import React from "react";
import { Reveal, Eyebrow, BrowserFrame } from "./MarketingUI";
import { Landmark, Workflow as WorkflowIcon, FileCheck2, ArrowDown } from "lucide-react";

const flow = [
  { icon: Landmark, label: "Official legislative source", note: "Authoritative government record" },
  { icon: WorkflowIcon, label: "GovFlowState ingestion", note: "Tracked, deduplicated, change-detected" },
  { icon: FileCheck2, label: "Structured legislative record", note: "Versions · votes · committees · history" },
  { icon: WorkflowIcon, label: "Agency workflow", note: "Assignments · analysis · reporting" },
];

export default function LiveProduct() {
  return (
    <section className="relative overflow-hidden bg-brand-navy-900 py-24 sm:py-28" data-testid="live-product-section">
      <div className="absolute inset-0 opacity-40" style={{ background: "radial-gradient(900px 400px at 80% 0%, rgba(8,127,131,0.25), transparent 60%)" }} />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow tone="light">The live product</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
              From official source to actionable intelligence.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/65">
              GovFlowState organizes official legislative information into a structured record your team can act on. It reflects the official record — it does not originate legislation.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid items-center gap-12 lg:grid-cols-[1fr_1.25fr]">
          {/* pipeline */}
          <div className="space-y-3">
            {flow.map((f, i) => (
              <Reveal key={f.label} delay={0.08 * i}>
                <div className="flex items-center gap-4 rounded-xl border border-white/10 bg-white/[0.04] px-5 py-4" data-testid={`live-flow-${i}`}>
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-lg bg-white/10">
                    <f.icon className="h-5 w-5 text-brand-civic-100" strokeWidth={1.9} />
                  </span>
                  <div>
                    <p className="font-display text-sm font-bold text-white">{f.label}</p>
                    <p className="text-xs text-white/55">{f.note}</p>
                  </div>
                </div>
                {i < flow.length - 1 && (
                  <div className="flex justify-center py-1"><ArrowDown className="h-4 w-4 text-brand-gold/70" /></div>
                )}
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <BrowserFrame url="app.govflowstate.com/bills/SB-28" testid="live-screenshot">
              <img src="/marketing/bill-detail.png" alt="GovFlowState structured legislative record with source link, versions, votes and assignment workflow" className="block w-full" loading="lazy" />
            </BrowserFrame>
            <p className="mt-3 text-xs text-white/45">Live record from a Florida legislative source, structured inside GovFlowState.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
